import React from 'react';
import { FC } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { homeRoutesURLs } from '../../constants/routes';

type Props = {
  isAuthenticated: boolean;
};

export const ProtectedRoute: FC<Props> = ({ isAuthenticated }) => {
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate
        to={homeRoutesURLs.loginPagePath}
        state={{ from: location }}
        replace
      />
    );
  }

  return <Outlet />;
};
